<template>
  <div class="inline-flex flex-col items-center">
    <div class="flex rounded-full border border-neutral-200 bg-white">
      <SfButton
        :id="`${id}-min-quantity-input`"
        :data-testid="`${id}-min-quantity-input`"
        variant="tertiary"
        :disabled="!!$attrs.disabled || count <= min"
        square
        class="rounded-l-full rounded-r-none"
        @click="preUpdateFn ? preUpdateFn('dec', count - 1) && dec() : dec()"
      >
        <SfIconRemove />
      </SfButton>
      <SfInput
        :id="`${id}-quantity-input`"
        v-model="count"
        :disabled="!!$attrs.disabled"
        type="number"
        class="!min-w-8 appearance-none text-center [-moz-appearance:textfield] disabled:text-disabled-500 [&::-webkit-inner-spin-button]:m-0 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:m-0 [&::-webkit-outer-spin-button]:appearance-none"
        wrapper-class="!px-0 !ring-0"
        :min="min"
        :max="max"
        @input="handleQuantity"
      />
      <SfButton
        :id="`${id}-max-quantity-input`"
        :data-testid="`${id}-max-quantity-input`"
        variant="tertiary"
        :disabled="!!$attrs.disabled || count >= max"
        square
        class="rounded-l-none rounded-r-full"
        @click="preUpdateFn ? preUpdateFn('inc', count + 1) && inc() : inc()"
      >
        <SfIconAdd />
      </SfButton>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { clamp } from '@storefront-ui/shared';
import { useCounter } from '@vueuse/core';

import type { InputQuantityProps } from '~/components/ui/InputQuantity/types';

const props = withDefaults(defineProps<InputQuantityProps>(), { max: 999, min: 1 });

const { count, dec, inc, set } = useCounter(props.start, { max: props.max, min: props.min });

const handleQuantity = (event: Event): void => {
  const target = event.target as HTMLInputElement;
  const currentValue = target?.value;
  const nextValue = parseFloat(currentValue);

  if (props.preUpdateFn && !props.preUpdateFn(count.value > nextValue ? 'dec' : 'inc', nextValue)) {
    target.value = count.value.toString();
    return;
  }

  if (!Number.isNaN(nextValue)) set(clamp(nextValue, props.min, props.max));
};

watch([count], () => {
  if (Number.isInteger(count.value)) emit('updateQuantity', count.value);
});

const emit = defineEmits(['updateQuantity']);
</script>
